<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9TfFro/tc-custom/9781497627062.jpg?1718106104090" alt="This image is the cover for the book Reluctant Swordsman, The Seventh Sword"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reluctant Swordsman, The Seventh Sword
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A young man is transformed into a barbarian fighter in this adventure from “one of the leading masters of epic fantasy” (<i>Publishers Weekly</i>)<i>.</i></b></p><p>Wallie Smith can feel the pain. He goes to the hospital and remembers the doctors and the commotion, but when he wakes up it all seems like a dream. However, if that was a dream, how do you explain waking up in another body and in another world? Little Wallie finds himself in the physique of a barbarian swordsman, accompanied by both an eccentric priest babbling about the Goddess and a voluptuous slave girl. Is this a rude awakening or a dream come true? What in the world will Wallie do now that he has found himself stranded in a strange realm? Well, it just so happens that the Goddess is in need of a swordsman. It will not be easy, but if he succeeds he will have everything he wants. If he does not, things could get ugly. Wallie is reluctant but sees his chance. If only he had the faintest clue as to the adventure he is about to unleash! If only he could imagine the forces that will be out to vanquish him! </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dave Duncan
      </h2>
      
      <p class="authorDescription body article">Dave Duncan (1933&ndash;2018) was born in Scotland, and received his diploma from Dundee High School and got his college education at the University of Saint Andrews. He moved to Canada in 1955, where he lived with his wife. Duncan spent thirty years as a petroleum geologist. He has had dozens of fantasy and science fiction novels published, among them <I>A Rose-Red City</I>, <I>Magic Casement</I>, and <I>The Reaver Road</I>, as well as a highly praised historical novel, <I>Daughter of Troy</I>, published, for commercial reasons, under the pseudonym Sarah B. Franklin. He also published the Longdirk series of novels, <I>Demon Sword</I>, <I>Demon Knight</I>, and <I>Demon Rider</I>, under the name Ken Hood.<BR /> &#160;<BR /> In the fall of 2007, Duncan&rsquo;s 2006 novel, <I>Children of Chaos</I>, published by Tor Books, was nominated for both the Prix Aurora Award and the Endeavour Award. In May 2013, Duncan, a 1989 founding member of SFCanada, was honored by election as a lifetime member by his fellow writers, editors, and academics. He passed away in 2018. Visit <a href="https://www.daveduncanauthor.com/">https://www.daveduncanauthor.com/ </a>for more information on the author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3949b00d